const guideFund = () => import(/* webpackChunkName: "fund" */ './Fund');

export default {
  routes: [
    {
      path: '/guide/fund',
      name: 'guideFund',
      component: guideFund
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/guide/fund/router.js